import { Injectable } from '@angular/core';
import { firstValueFrom, Observable, of } from 'rxjs';
import { finalize, map, shareReplay, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ApiHandler } from './api.handler';

export type ClientConfigType = 'StripeKey' | 'GoogleMapsKey' | 'AzureMapsToken' | 'StaxWebToken';

@Injectable({
  providedIn: 'root'
})
export class ClientConfigService {
  private readonly memory = new Map<ClientConfigType, string>();
  private readonly pending = new Map<ClientConfigType, Observable<string>>();

  constructor(private apiHandler: ApiHandler) {}

  get(keyType: ClientConfigType): Observable<string> {
    const cached = this.memory.get(keyType);
    if (cached) {
      return of(cached);
    }

    const existing = this.pending.get(keyType);
    if (existing) {
      return existing;
    }

    const request = this.apiHandler
      .post(`${environment.API_URL.Accountkit.url}/api/AccountKit/GetClientConfig`, { keyType })
      .pipe(
        map((res: any) => {
          const value = res && (res.value || res.Value);
          if (!value) {
            throw new Error('The requested key is temporarily unavailable.');
          }
          return value as string;
        }),
        tap((value) => this.memory.set(keyType, value)),
        finalize(() => this.pending.delete(keyType)),
        shareReplay(1)
      );
    this.pending.set(keyType, request);
    return request;
  }

  getValue(keyType: ClientConfigType): Promise<string> {
    return firstValueFrom(this.get(keyType));
  }
}
